import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthenticationService } from "./authentication.service";

@Injectable({
  providedIn: "root",
})
export class AccessPermissionService {
  constructor(private readonly authService: AuthenticationService) {}
  userPermission: any[] = [];
  isFullAccess: boolean = false;

  setPermissions(value: any[]) {
    this.userPermission = Array.isArray(value) ? value : [];
  }

  getPermission() {
    if (this.userPermission.length == 0) {
      let localData = localStorage.getItem("accessPermission") || "";
      this.userPermission = localData != "" ? JSON.parse(localData) : [];
    }
    // console.log("permissions: ",this.userPermission)
    return this.userPermission;
  }

  hasFullAccess(): boolean {
    return (
      this.authService.isFullAccess() === true ||
      localStorage.getItem('isFullAccess') === 'true'
    );
  }

  private normalizePermissionName(value: unknown): string {
    return String(value ?? '').trim();
  }

  hasPermission(permission: string) {
    if (this.hasFullAccess()) {
      return true;
    }
    const required = this.normalizePermissionName(permission);
    if (!required) {
      return false;
    }
    let permissionArray = this.getPermission();
    let isPermission = permissionArray.find(
      (item: any) => this.normalizePermissionName(item?.permissionName) === required
    );
    if (isPermission) {
      return true;
    } else {
      return false;
    }
  }

  hasMultiplePermission(permissions: any[]) {
    if (this.hasFullAccess()) {
      return true;
    }
    // Missing/empty access list = no access (menus must declare permissions).
    if (!Array.isArray(permissions) || permissions.length === 0) {
      return false;
    }
    const required = permissions
      .map((permission) => this.normalizePermissionName(permission))
      .filter((permission) => !!permission);
    if (required.length === 0) {
      return false;
    }
    let permissionArray = this.getPermission();
    let values = permissionArray?.length > 0 ? permissionArray.filter((value: any) =>
      required.includes(this.normalizePermissionName(value?.permissionName))
    ) : [];
    if (values.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  private dataSource = new BehaviorSubject<boolean>(false);
  closeSidebar = this.dataSource.asObservable();
  updateSidebar(data: boolean) {
    this.dataSource.next(data);
  }

  private showNotification = new BehaviorSubject<boolean>(false);
  displayNotification = this.showNotification.asObservable();
  triggerNotification(data: boolean) {
    this.showNotification.next(data);
  }

  private lastRoute: string = "";
  private lastQueryParams: any = {};

  setLastRoute(route: string, queryParams: any) {
    this.lastRoute = route;
    this.lastQueryParams = queryParams;
  }

  getLastRoute(): string {
    return this.lastRoute;
  }

  getLastQueryParams(): any {
    return this.lastQueryParams;
  }
}
